import MuiBreadcrumbs, { BreadcrumbsProps } from "@mui/material/Breadcrumbs";

const Breadcrumbs: React.FC<BreadcrumbsProps> = MuiBreadcrumbs;

export default Breadcrumbs;
export type { BreadcrumbsProps };
